// @ts-nocheck
import buttonSizeVariants from "@insite/mobius/Button/buttonSizeVariants";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";

/** buttonSizeVariants
 * ------------------------------------------------------------------------------------------
 * height: Height applied as "min-height" (px)
 * fontSize: Font size (px)
 * padding: CSS applied to the padding property "padding: [VALUE];"
 * icon: Icon size (px)
 * iconPadding: Spacing between the icon and the text (px)
 */

/* Store Custom Code - Start */
Object.assign(buttonSizeVariants, {
    small: {
        height: 36,
        fontSize: 12,
        padding: pxToRem(8, 16),
        icon: 24,
        iconPadding: 8,
    },
    medium: {
        height: 46,
        fontSize: 12,
        padding: pxToRem(10, 20),
        icon: 24,
        iconPadding: 8,
    },
    large: {
        height: 52,
        fontSize: 13,
        padding: pxToRem(10, 20),
        icon: 24,
        iconPadding: 8,
    },
    xlarge: {
        height: 52,
        fontSize: 13,
        padding: pxToRem(10, 20),
        icon: 24,
        iconPadding: 8,
    },
});
/* Store Custom Code - End */
